import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const LearningTask = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={20}
      viewBoxHeight={20}
    >
      <mask
        id={mask2Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="16"
        height="16"
      >
        <mask
          id={mask1Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path fill="#D9D9D9" d="M0 0h20v20H0z" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M6.667 14.167c.236 0 .434-.08.593-.24.16-.16.24-.358.24-.594a.806.806 0 0 0-.24-.593.806.806 0 0 0-.593-.24.806.806 0 0 0-.594.24.806.806 0 0 0-.24.593c0 .236.08.434.24.594.16.16.358.24.594.24Zm0-3.334c.236 0 .434-.08.593-.24.16-.159.24-.357.24-.593a.806.806 0 0 0-.24-.594.806.806 0 0 0-.593-.24.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24Zm0-3.333c.236 0 .434-.08.593-.24.16-.16.24-.357.24-.593a.806.806 0 0 0-.24-.594.806.806 0 0 0-.593-.24.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594c0 .236.08.434.24.593.16.16.358.24.594.24ZM10 14.167h3.333c.236 0 .434-.08.594-.24.16-.16.24-.358.24-.594a.806.806 0 0 0-.24-.593.807.807 0 0 0-.594-.24H10a.806.806 0 0 0-.594.24.806.806 0 0 0-.24.593c0 .236.08.434.24.594.16.16.358.24.594.24Zm0-3.334h3.333c.236 0 .434-.08.594-.24.16-.159.24-.357.24-.593a.806.806 0 0 0-.24-.594.806.806 0 0 0-.594-.24H10a.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24ZM10 7.5h3.333c.236 0 .434-.08.594-.24.16-.16.24-.357.24-.593a.806.806 0 0 0-.24-.594.806.806 0 0 0-.594-.24H10a.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594c0 .236.08.434.24.593.16.16.358.24.594.24Zm-5.833 10c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h11.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177v11.666c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H4.167Zm0-1.667h11.666V4.167H4.167v11.666Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask2Id})`}>
        <path d="M0 0h20v20H0z" />
      </g>
    </Icon>
  );
};

LearningTask.displayName = 'LearningTask';

export default LearningTask;
